import { createSlice } from "@reduxjs/toolkit";
import { EmailApprovalSaga } from "./saga";
import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { useMemo } from "react";

export const initialState = {
  userApproval: {
    loading: false,
    error: null,
    data: null,
    success: false
  },

  userAction: {
    loading: false,
    error: null,
    success: false
  }
};

export const EmailApprovalSlice = createSlice({
  name: "emailApproval",
  initialState,
  reducers: {
    // =====================
    // GET USER DETAILS
    // =====================
    fetchUserApproval: (state) => {
      state.userApproval.loading = true;
      state.userApproval.error = null;
      state.userApproval.success = false;
    },

    fetchUserApprovalSuccess: (state, action) => {
      state.userApproval.loading = false;
      state.userApproval.data = action.payload;
      state.userApproval.success = true;
    },

    fetchUserApprovalFailure: (state, action) => {
      state.userApproval.loading = false;
      state.userApproval.error = action.payload;
      state.userApproval.success = false;
    },

    resetUserApproval: (state) => {
      state.userApproval = initialState.userApproval;
    },

    // =====================
    // USER ACTIONS (ACTIVATE / DISABLE)
    // =====================

    activateUserRequest: (state) => {
      state.userAction.loading = true;
      state.userAction.error = null;
      state.userAction.success = false;
    },

    disableUserRequest: (state) => {
      state.userAction.loading = true;
      state.userAction.error = null;
      state.userAction.success = false;
    },

    userActionSuccess: (state) => {
      state.userAction.loading = false;
      state.userAction.success = true;
    },

    userActionFailure: (state, action) => {
      state.userAction.loading = false;
      state.userAction.error = action.payload;
    },

    resetUserAction: (state) => {
      state.userAction = initialState.userAction;
    }
  }
});

export const useEmailApprovalSlice = () => {
  useInjectReducer(EmailApprovalSlice.name, EmailApprovalSlice.reducer);
  useInjectSaga(EmailApprovalSlice.name, EmailApprovalSaga);

  const actions = useMemo(() => EmailApprovalSlice.actions, []);
  return { actions };
};

export const { actions: emailApprovalActions } = EmailApprovalSlice;
export default EmailApprovalSlice.reducer;
